import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'
import DataTablesSchema, {
  CustomActionButtonSchema,
  MapColumnToActionSchema,
  TableActionsVisibilitySchema
} from 'sitemodel/schema/components/DataTablesSchema'
import { z } from 'zod/v4'

export type DataTablesProps = schemaToReactType<typeof DataTablesSchema>

export type CustomActionButtonProps = z.infer<typeof CustomActionButtonSchema>

export type MapColumnToAction = z.infer<typeof MapColumnToActionSchema>

export type TableActionsVisibility = z.infer<
  typeof TableActionsVisibilitySchema
>

export const DataTablesTypeGuard = schemaToTypeGuard(DataTablesSchema)
